/* @flow */

import React from 'react';
import { Link } from 'react-router-dom';
import PropTypes from '../util/prop_types';
import config from '../config';

export default class Header extends React.Component {
  render(): ?React.Element<any> {
    return (
      <header>
        <div id="cplogo">
          <a href="http://www.calpoly.edu">
            <img
              title="Go to Cal Poly Home"
              alt="Cal Poly"
              src="../../images/logo-cal-poly.svg" />
          </a>
        </div>
        <h1 id="sitename">
          <Link to="/">
            Campus Maps & Directions
          </Link>
        </h1>
        <div id="AFD-Services">
          <a href="https://afd.calpoly.edu/services">AFD SERVICES</a>
        </div>
      </header>
    );
  }
}
